import React from 'react';
import { DraftSpecialTextConfiguration } from '@/types';
import { scaleSize } from '@/model/configuration/scaleSize';
import { SoftBoundary } from '../SoftBoundary';

export const useSpecialText = (
  configuration: DraftSpecialTextConfiguration,
  offset = configuration.offset,
  rotation = configuration.rotation,
  scale = configuration.scale
) => {
  const configurationSize = configuration.size;
  const previewUrl = configuration.task.previewUrl;
  const scaledSize = scaleSize(configurationSize, scale);
  const transformScale = `scale(${scale}, ${scale})`;

  const textElement = (
    <SoftBoundary
      cid={configuration.cid}
      printArea={configuration.printArea}
      rotation={rotation}
      size={scaledSize}
      offset={offset}
    >
      <g transform={transformScale}>
        <image
          key={previewUrl}
          xlinkHref={previewUrl}
          width={configurationSize.width}
          height={configurationSize.height}
        />
      </g>
    </SoftBoundary>
  );

  const transform = `translate(${offset.x}, ${offset.y}) rotate(${rotation}, ${
    scaledSize.width / 2
  }, ${scaledSize.height / 2})`;

  return [textElement, transform] as const;
};
